import { CashboxStatement } from "src/common/models/cashboxStatement";
import * as ActionTypes from "./actionTypes";
import { ContractPaymentError, ContractPaymentErrorOrigin } from "./types";
import { ErrorAction } from "src/common/apiLoader/state/actions";
import { parseDataKey } from "src/common/util";
import { GetCashboxStmtRecordsSuccessAction, GetContractPaymentRecordsSuccessAction } from "./action";
import { ServiceContractPayment } from "src/common/models/serviceContractDebitPayment";

export interface ContractPaymentState {
    error?: ContractPaymentError | undefined
    createContractPaymentSuccess: boolean
    cashboxStmtRecords?: CashboxStatement[]
    cashboxBalance: number
    contractPayments?: ServiceContractPayment[]
    sendPaymentReceiptSuccess: boolean
}

const initialState: ContractPaymentState = {
    createContractPaymentSuccess: false,
    cashboxBalance: 0,
    sendPaymentReceiptSuccess: false,
}

const contractPaymentReducer = (state: ContractPaymentState = initialState, action: any): ContractPaymentState => {
    switch (action.type) {
        case ActionTypes.CREATE_CONTRACT_PAYMENT_API: {
            return {
                ...state,
                createContractPaymentSuccess: false,
                error: undefined,
            }
        }
        case ActionTypes.CREATE_CONTRACT_PAYMENT_API_SUCCESS: {
            return {
                ...state,
                createContractPaymentSuccess: true,
            }
        }
        case ActionTypes.CREATE_CONTRACT_PAYMENT_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ContractPaymentErrorOrigin.CREATE_CONTRACT_PAYMENT,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_CASHBOX_STATEMENT_RECORDS_API: {
            return {
                ...state,
                cashboxStmtRecords: undefined,
                error: undefined,
            }
        }
        case ActionTypes.GET_CASHBOX_STATEMENT_RECORDS_API_SUCCESS: {
            const successAction = action as GetCashboxStmtRecordsSuccessAction

            return {
                ...state,
                cashboxStmtRecords: parseDataKey(successAction.cashboxStatements),
                cashboxBalance: successAction.balance,
            }
        }
        case ActionTypes.GET_CASHBOX_STATEMENT_RECORDS_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ContractPaymentErrorOrigin.GET_CASHBOX_STMT_RECORDS,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_CONTRACT_PAYMENT_RECORDS_API: {
            return {
                ...state,
                contractPayments: undefined,
                error: undefined,
            }
        }
        case ActionTypes.GET_CONTRACT_PAYMENT_RECORDS_API_SUCCESS: {
            const successAction = action as GetContractPaymentRecordsSuccessAction

            return {
                ...state,
                contractPayments: parseDataKey(successAction.contractPayments),
            }
        }
        case ActionTypes.GET_CONTRACT_PAYMENT_RECORDS_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ContractPaymentErrorOrigin.GET_CONTRACT_PAYMENTS,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.SEND_CONTRACT_PAYMENT_RECEIPT_API: {
            return {
                ...state,
                sendPaymentReceiptSuccess: false,
                error: undefined,
            }
        }
        case ActionTypes.SEND_CONTRACT_PAYMENT_RECEIPT_API_SUCCESS: {
            return {
                ...state,
                sendPaymentReceiptSuccess: true,
            }
        }
        case ActionTypes.SEND_CONTRACT_PAYMENT_RECEIPT_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: ContractPaymentErrorOrigin.SEND_CONTRACT_PAYMENT_RECEIPT,
                    detail: errorAction.error,
                }
            }
        }
    }
    return state;
};


export default contractPaymentReducer;